module.exports = __webpack_public_path__ + "img/lowcode-2-1.9f95d76e.svg";